import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';
import NumberFormat from 'react-number-format';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH } from "../../Utils/Global";
import { getDateFromString, getIsoStringFromDate, getStringFromDate } from "../../Utils/Date";
import { cloneObject } from "../../Utils/Utils";

import Combobox from '../Helper/Combobox';
import RemoteRadioGroup from '../Helper/RemoteRadioGroup';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';

/**
* Class FacturationEncaissement
* FacturationEncaissement view component
**/
class FacturationEncaissement extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "FacturationEncaissement";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    // Transforms date fields
    let date = null;

    if(this.state.object !== undefined) {
      if(this.state.object.date) {

        date = this.state.object.date;

        if(typeof date === "string") {
          date = getDateFromString(date);
        }

        date = getIsoStringFromDate(date);
      }
    }

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form ref="facturationEncaissementForm" horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de facturation</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idFacturationEncaissement" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idFacturationEncaissement")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="idTypeFacturationEncaissement">
            <Col componentClass={ControlLabel} smOffset={2} sm={4}>
              <RemoteRadioGroup path="typefacturationencaissements" refField="idTypeFacturationEncaissement" valueField="idTypeFacturationEncaissement" labelField="libelle"
              onChange={this.handleRadioChange.bind(this)} value={this.getObjectProperty("idTypeFacturationEncaissement")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Date</Col>
            <Col sm={2}><DatePicker id="date" dateFormat="DD/MM/YYYY" value={date} onChange={this.handleDateChange.bind(this)} disabled={this.getReadOnly()} /></Col>
            <Col componentClass={ControlLabel} sm={1}>Année</Col>
            <Col sm={2}>
              <FormControl id="annee" type="number" min={1980} max={2100} onChange={this.handleChange} value={this.getObjectProperty("annee")} placeholder="Annee"
                disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {!this.getObjectProperty("idTypeFacturationEncaissement") || this.getObjectProperty("idTypeFacturationEncaissement") === 1 || this.getObjectProperty("idTypeFacturationEncaissement") === "1" ?
            <FormGroup>
              <Col componentClass={ControlLabel} sm={2}>Numéro de facture</Col>
              <Col sm={2}><FormControl id="numeroFacture" type="text" value={this.getObjectProperty("numeroFacture")} onChange={this.handleChange} /></Col>
              <Col componentClass={ControlLabel} sm={1}>Référence</Col>
              <Col sm={2}><FormControl id="reference" type="text" value={this.getObjectProperty("reference")} onChange={this.handleChange} /></Col>
            </FormGroup> :

            <FormGroup controlId="numeroFacture">
              <Col componentClass={ControlLabel} sm={2}>Référence facture</Col>
              <Col sm={2}>
                <Combobox ref="numeroFacture" url={REST_API_URL + "contrats/" + (this.getObjectProperty("idContrat") || this.props.match.params.idContrat) + "/facturations"}
                  optionValueKey="numeroFacture" optionLabelKey="numeroFacture" default={this.getObjectProperty("numeroFacture")} onChange={this.handleReferenceFactureSelect.bind(this)}
                  placeholder="Référence facture" searchable={true} disabled={this.getReadOnly()} />
              </Col>
            </FormGroup>
          }


          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>
              {!this.getObjectProperty("idTypeFacturationEncaissement") ||
              this.getObjectProperty("idTypeFacturationEncaissement") === 1 || this.getObjectProperty("idTypeFacturationEncaissement") === "1" ?
                "Montant HT" : "Montant"}</Col>
            <Col sm={2}>
              <NumberFormat className="form-control" value={this.getObjectProperty("montant")} onValueChange={this.handleMontantChange.bind(this)}
                decimalScale={2} thousandSeparator={" "} suffix={'€'} disabled={this.getReadOnly()} />
            </Col>
          </FormGroup>

          <FormGroup controlId="observation">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Observation</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("observation")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" onClick={this.submit.bind(this)}>Sauvegarder</Button>
              </Col>
            </FormGroup>: null
          }
        </Form>
      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idFacturationEncaissement";
  }

  /**
  * submit
  * Saves the data
  **/
  submit () {
    let method;
    const path = REST_API_URL + this.getObjectPath();

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
    }

    let facturationEncaissementObj = cloneObject(this.state.object);

    // if(!facturationEncaissementObj.idTypeFacturationEncaissement) {
      facturationEncaissementObj.idTypeFacturationEncaissement = 1;
    // }

    if(typeof facturationEncaissementObj.date !== "string") {
      facturationEncaissementObj.date = getStringFromDate(facturationEncaissementObj.date);
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(facturationEncaissementObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.setState({
          status: {
            type: 'success',
            message: 'Facturation sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Facturation créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/facturationencaissements/" + newObj.idFacturationEncaissement + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }

      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * handleDateChange
  * Modify the state date property from date field change
  **/
  handleDateChange(dateString, formattedDate) {
    let objState = this.state;
    objState.object["date"] = (dateString !== null) ? new Date(dateString) : null;
    this.setState(objState);
  }

  /**
  * handleReferenceFactureSelect
  * Handle reference facture onChange event
  **/
  handleReferenceFactureSelect(referenceFacture) {
    let objState = this.state;
    objState.object["numeroFacture"] = referenceFacture.numeroFacture;
    this.setState(objState);
  }

  /**
  * handleMontantChange
  * Handle montant change
  **/
  handleMontantChange(values) {
    let objState = this.state;
    objState.object["montant"] = values.value;
    this.setState(objState);
  }

}
export default FacturationEncaissement;



// WEBPACK FOOTER //
// ./src/views/Entity/FacturationEncaissement.js